<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span
      class="
        cursor-pointer
        flex
        items-center
        border-0
        md:border-r
        border-solid border-grey-light
        mr-4
        pr-2
      "
    >
      <feather-icon icon="PocketIcon" class="cursor-pointer mt-1" />
      <strong class="hidden sm:block ml-2 mr-10">{{ strategy.name }}</strong>
    </span>

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <p class="opacity-75">Choose branch</p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="str in strategies"
            :key="str.id"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
            @click="setActiveStrategy(str)"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="str.icon"
                svgClasses="['text-primary', 'stroke-current mr-1 h-6 w-6']"
              ></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title">{{
                  str.name
                }}</span>
              </div>
            </div>
          </li>
        </ul>
      </component>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    strategies () {
      const activeStrategyId = this.$store.state.AppActiveUser.activeStrategyId
      const mapped = this.$store.state.AppActiveUser.strategies.map(str => {
        return { id: str.id, name: str.displayName, icon: str.id === activeStrategyId ? "CheckIcon" : "MinusIcon" }
      })
      if (this.$acl.check('user')) {
        mapped.unshift({ id: 0, name: this.$t("All"), icon: activeStrategyId === 0 ? "CheckIcon" : "MinusIcon" })
      }
      return mapped
    },
    activeCampaignId () {
      return this.$store.state.AppActiveUser.activeCampaignId
    },
    strategy () {
      const activeStrategyId = this.$store.state.AppActiveUser.activeStrategyId
      const strategy = this.strategies.find(str => {
        return str.id === activeStrategyId
      }
      )
      if (strategy) {
        return strategy
      }
      if (this.$acl.check('user') || this.strategies.lenght == 0) {
        return { id: 0, name: "Onbekend" }
      }
      return this.strategies[0]
    }
  },
  methods: {
    setActiveStrategy (strategy) {
      const activeStrategyId = this.$store.state.AppActiveUser.activeStrategyId
      if (strategy.id !== activeStrategyId) {
        this.$store.dispatch("updateActiveStrategy", strategy.id)
      }
    }
  },
  watch: {
    activeCampaignId: function () {
      this.$store.dispatch("refreshStrategies", this.activeCampaignId)
    },
  },
}

</script>

